import { IframeUtility } from '@inter-ikea-kompis/utilities';
import { getPlatformService } from './ServiceHandler';

import emitter from '../emitter';
import { IFRAME_RESIZED } from '../settings/events';

const appElement = document.getElementById('root');
const bodyStyle = window.getComputedStyle(appElement);
const border =
  parseInt(bodyStyle.getPropertyValue('border-top-width'), 10) +
  parseInt(bodyStyle.getPropertyValue('border-bottom-width'), 10);

let previousWidth;
let trailingUpdateTimeout;
let trailingEmitTimeout;
let requirementsProviders = [];

function setHeight(height) {
  getPlatformService().setIframeHeight(height);
}

function update(timeoutCall) {
  clearTimeout(trailingUpdateTimeout);
  clearTimeout(trailingEmitTimeout);

  const width = window.innerWidth;
  const currentHeight = window.innerHeight;
  const calculatedHeight = IframeUtility.calculateHeight(width);

  appElement.style.minHeight = `${calculatedHeight - border}px`;

  const height = Math.max(
    ...requirementsProviders.map(provider => provider()),
    calculatedHeight,
    appElement.offsetHeight
  );

  if (height !== currentHeight) {
    setHeight(height);
  }

  if (timeoutCall || width !== previousWidth || height !== currentHeight) {
    emitter.emit(IFRAME_RESIZED);

    trailingEmitTimeout = setTimeout(() => emitter.emit(IFRAME_RESIZED), 100);
  }

  previousWidth = width;

  if (!timeoutCall) {
    // sometimes when resizing furiously the iframe can get stuck in an incorrect
    // size. this timeout prevents this
    trailingUpdateTimeout = setTimeout(update, 500, true);
  }
}

function addHeightProvider(fn) {
  requirementsProviders.push(fn);
  update();
}

function removeHeightProvider(fn) {
  requirementsProviders = requirementsProviders.filter(
    callback => callback !== fn
  );
  update();
}

export default {
  addHeightProvider,
  removeHeightProvider,
  setHeight,
  update,
};
